import React, { useEffect, useState } from 'react'
import Header from '../../components/Header'
import SearchInput from '../../components/SearchInput'
import { authAxios } from '../../helpers/axios'
import { toast } from 'react-toastify'
import FilterSelect from '../../components/FilterSelect'
import { useNavigate,useLocation, Link } from 'react-router-dom'
import ManageOrder from './components/ManageOrder'
import { ErrorToast, InfoToast } from '../../helpers/toasters'
import ViewOrder from './components/ViewOrder'
import { LIMIT } from '../../helpers/constants'
import RightIcon from '../../images/right.svg'
import SortIcon from '../../images/sort.svg'
import FilterIcon from '../../images/filter.svg'
import RupeeIcon from '../../images/rupee.svg'
import FilterActiveIcon from '../../images/filteractive.svg'
import FilterOrder from './components/FilterOrder'
import Toast from 'react-toastify'
import { getDateFormat, getTimeFormat, renderWeight } from '../../helpers/utils'
import CreatePurchaseOrder from './components/CreatePurchaseOrder'
import Progress from '../../components/Progress'

export default function ManufacturingOrder() {

    const location = useLocation()
    const [searchText,setSearchText] = useState('')
    const [reps,setOrders] = useState([])
    const [showManage,setShowManage] = useState({status:false,edit:null})
    const [vieworder,setVieworder] = useState(false)
    const [sort,setSort] = useState('-createdAt')
    const [exporting,setExporting] = useState(false)

    const [cityFilters,setCityFilters] = useState([])
    const [routeFilters,setRouteFilters] = useState([])
    const navigate = useNavigate()
    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(5)
    const [summary,setSummary] = useState({pendingOrders:0,totalOrders:0,cancelledOrders:0,totalAmount:0,totalQty:0})
    const [filters,setFilters] = useState({routeId:null,cityId:null,status:null,distributorId:null,retailerId:null,teamId:null,salesRepId:null,startDate:null,endDate:null})
    const [showFilters,setShowFilters] = useState(false)
    const [submitting,setSubmitting] = useState(false)
    

    const [selectedFilters,setSelectedFilters] = useState({city:'',route:''})

    async function exportOrders(){

        try 
        {
            setExporting(true)
            let query = `limit=${LIMIT}&offset=${offset}&search=${searchText}&populate=true&sort=${sort}&status=-shipping-ready`;
            if(filters.status) query+=`&status=${filters.status}`
            if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let response = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/orders/export?${query}`,{responseType:'blob'})
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element
            const link = document.createElement('a');
            link.href = url;

            // Set the filename for the downloaded file
            link.setAttribute('download', 'retailers_export.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Cleanup
            link.parentNode.removeChild(link);
            setExporting(false)
        } catch (error) {
            setExporting(false)
            console.log(error)
            toast('Error getting orders')
        }
    } 

    const RightContent = ()=>
    {
        return <div>

        </div>
    }

    async function getOrders(filters,sort,offset,searchText){

        try 
        {
            let query = `limit=${LIMIT}&offset=${offset}&search=${searchText}&populate=true&sort=${sort}&status=-shipping-ready`;
            if(filters.buyerId) query+=`&buyerId=${filters.buyerId}`
            if(filters.status) query+=`&status=${filters.status}`
            if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/production?${query}`)
            setOrders(res.data.orders)
            setCount(res.data.totalCount)

        } catch (error) {
            console.log(error)
            toast('Error getting orders')
        }
    } 

    async function getOrderSummary(){

        try 
        {
            console.log('filters',filters)
            let query = `limit=${LIMIT}&offset=${offset}&search=${searchText}&populate=true&sort=${sort}`;
            // if(filters.cityId) query+=`&cityId=${filters.cityId.id}`
            // if(filters.routeId) query+=`&routeId=${filters.routeId.id}`
            // if(filters.retailerId) query+=`&retailerId=${filters.retailerId.id}`
            // if(filters.distributorId) query+=`&distributorId=${filters.distributorId.id}`
            // if(filters.salesRepId) query+=`&salesRepId=${filters.salesRepId.id}`
            // if(filters.teamId) query+=`&salesTeamId=${filters.teamId.id}`
            // if(filters.status) query+=`&orderStatus=${filters.status}`
            if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/order-summary?${query}`)
            if(res.data.data)
            {
                setSummary({...res.data.data})
                // setOffset(offset+LIMIT)
            }
        } catch (error) {
            console.log(error)
            toast('Error getting orders')
        }
    } 

    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
            const params = new URLSearchParams(location.search);
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.set(key, filters[key]);
                } else {
                    params.delete(key);
                }
            });
            if(searchText) params.set('search',searchText)
            if(sort) params.set('sort',sort)
            params.set('offset', 0); // Reset offset to 0 when applying filters
            navigate(`?${params.toString()}`);
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({routeId:null,cityId:null,status:null,distributorId:null,retailerId:null,teamId:null,salesRepId:null,startDate:null,endDate:null})
            setShowFilters(false)
            setOffset(0); // Reset offset to 0 when clearing filters
        } catch (error) {
            toast('Order Filtered')
        }
    }


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const search = params.get('search') || '';
        const sort = params.get('sort') || '-createdAt';
        const offset = parseInt(params.get('offset')) || 0;
        const filters = {
            status: params.get('status') || null,
            buyerId: params.get('buyerId') || null,
            startDate: params.get('startDate') || null,
            endDate: params.get('endDate') || null,
        };

        setSearchText(search);
        setSort(sort);
        setOffset(offset);
        setFilters(filters);

        if (search !== '' || Object.values(filters).some(value => value !== null)) {
            getOrders(filters,sort,offset,search);
        }
    }, [location.search]);


    useEffect(()=>
    {
        getOrders(filters,sort,offset,searchText);
        // getOrderSummary();
    },[offset,searchText,filters,sort])


    const onOrderCreate = async(e,manageData)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitting(true)
            let orderProducts=[];
            manageData.products.map((item,index)=>
            {
                if(item && ((item.quantity && item.quantity > 0) || (item.product)) ) return orderProducts.push({productId:item.productId,quantity:item.quantity})
            })
            let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/manufacturing`,{...manageData,products:orderProducts})  
            getOrders()
            setShowManage(false)
            setSubmitting(false)
            InfoToast('Order Created')
        } catch (error) {
            setSubmitting(false)
            ErrorToast('Order Creating Failed')
            
        }
    }

    const onSortPress = (type)=>
    {
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
          } else {
            setSort(type);
          }
        const params = new URLSearchParams(location.search);
        params.set('sort', sort);
        params.set('offset', 0); // Reset offset to 0 when sorting
        navigate({ search: params.toString() });
    }

    const onPageChange = (newOffset) => {
        if (newOffset >= 0 && newOffset < count) {
            setOffset(newOffset);
            const params = new URLSearchParams(location.search);
            params.set('offset', newOffset);
            navigate({ search: params.toString() });
        }
    }

    const onSearchChange = (value) => {
        setSearchText(value);
        setOffset(0); // Reset offset to 0 when searching
        const params = new URLSearchParams(location.search);
        params.set('search', value);
        params.set('offset', 0); // Reset offset to 0 when searching
        navigate({ search: params.toString() });
    }

  return (
    <>
        <Header title={'Manufacturing Order Management'} RightContent={RightContent}/>
        <div className=' flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
            <div className='flex'>
                <SearchInput value={searchText} setValue={onSearchChange} placeholder={'Search Order'} label={'Search Order'} />
                <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={()=>onPageChange(offset-LIMIT)}
                    >
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180' alt='Previous Page' />
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={() => onPageChange(offset+LIMIT)}>
                        <img src={RightIcon} className='w-[20px] h-[20px]' alt='Next Page' />
                    </div>
                    </div>
            </div>
            <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.startDate || filters.endDate) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        <div className='bg-white w-full flex-1 flex overflow-scroll'>
            <table className=' table-auto w-full flex-1 '>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                
                    <td><p onClick={()=>onSortPress('salesOrderId')} className='cursor-pointer flex items-center hover:text-black'>Sales Order ID {sort === 'salesOrderId' || sort === '-salesOrderId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>{}} className='cursor-pointer flex items-center hover:text-black'>Buyer {sort === 'buyerId' || sort === '-buyerId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('expectedDeliveryDate')} className='cursor-pointer flex items-center hover:text-black'>Delivery/Ordered Date {sort === 'expectedDeliveryDate' || sort === '-expectedDeliveryDate'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('createdAt')} className='cursor-pointer flex items-center hover:text-black'>Progress {sort === 'createdAt' || sort === '-createdAt'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>{}} className='cursor-pointer flex items-center hover:text-black'>Quantity {sort === 'quantity' || sort === '-quantity'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>{}} className='cursor-pointer flex items-center hover:text-black'>Products {sort === 'totalProducts' || sort === '-totalProducts'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status {sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    {/* <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status {sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td> */}
                    {/* <td><p>Action</p></td> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        reps.map((item,index)=>
                        {
                            return <Link to={`/manufacturing/${item.id}`} key={index}>
                                <tr>
                                <td className='capitalize w-full'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>#{item.salesOrder.orderId}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.salesOrder?.buyer?.name ? item.salesOrder.buyer.name : '-'}</p>
                                    </div>
                                </td>
                                {/* <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{getDateFormat(item.orderDate)}</p>
                                    </div>
                                </td> */}
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{getDateFormat(item.createdAt)}</p>
                                        <p className='text-[13px] text-gray-400 my-0'>{item.expectedDeliveryDate ? getDateFormat(item.expectedDeliveryDate) : 'Not Available'}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <Progress percentage={item.progressPercentage}/>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.totalCartons}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.totalProducts}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className={`text-[13px] font-medium px-3 inline-block py-1 rounded-md ${item.status ===  'pending' ? 'text-[#454545] bg-gray-200 ' : item.status ===  'initiated' ? 'bg-[#39C7A5] bg-opacity-50 text-green-700 ' : 'text-red-700 bg-red-200 bg-opacity-10'}}`}>{item.status}</p>
                                    </div>
                                </td>
                            </tr>
                            </Link>
                        })
                    }
                </tbody>
            </table>
        </div>
        {/* <div className=' flex justify-between items-stretch border-t border-[#e3e3e3] bg-white w-full'>
            <div className='flex px-6 py-2 justify-between w-full'>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Orders(Total/Cancelled/Pending) - {summary.totalOrders}/{summary.cancelledOrders}/{summary.pendingOrders}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Points - {summary.totalPoints}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Weight - {(summary.totalWeight/1000).toFixed(2)}Kgs</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Amount - {summary.totalAmount}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Qty - {summary.totalQty}</p>
            </div>
        </div> */}
        { showManage.status ? <CreatePurchaseOrder submitting={submitting} onClose={setShowManage} edit={showManage.edit} onSubmit={onOrderCreate}/> : null}
        { vieworder ? <ViewOrder getOrders={getOrders} onClose={setVieworder} id={vieworder}/> : null}
        { showFilters ? <FilterOrder onSubmit={onFilterSubmit} id={vieworder} filters={filters} onClose={setShowFilters} clearFilter={clearFilter}/> : null}
    </>
  )
}

